/* Copyright (c) 2023 Xperi. All Rights Reserved. */

import { AppError } from './AppError';

export class PlaybackError extends AppError {
    protected subCode: string | undefined;

    setSubCode(subCode: string) {
        this.subCode = subCode;
    }

    getSubCode() {
        return this.subCode;
    }
}
